import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { useIsMobile } from '../../../../utils/hooks';
import FooterLink from './FooterLink';
import '../../assets/css/footer_nav.css';
import { FOOTER_COLUMNS } from './utils/footerLinks';
import { useVisibleFooterSections } from './utils/useVisibleFooterSections';

const MOBILE_MAX_WIDTH_PX = 767;

function FooterLinkList({ links }) {
  return (
    <ul className='sbf-link-list display-flex-column'>
      {links.map((link) => (
        <li key={link.label}>
          <FooterLink link={link} />
        </li>
      ))}
    </ul>
  );
}

function FooterNav() {
  const isMobile = useIsMobile(MOBILE_MAX_WIDTH_PX);
  const columns = useVisibleFooterSections(FOOTER_COLUMNS);

  if (isMobile) {
    return (
      <nav aria-label='Footer' className='sbf-nav sbf-accordion'>
        {columns.map(({ key, title, links }) => (
          <details
            key={key}
            name='sbf-footer-nav'
            className='sbf-accordion__panel'
          >
            <summary className='sbf-accordion__summary'>
              <h2 className='sbf-heading fs-13 uppercase gBold white'>
                {title}
              </h2>
              <DownOutlined className='sbf-accordion__icon fs-14' aria-hidden />
            </summary>
            <FooterLinkList links={links} />
          </details>
        ))}
      </nav>
    );
  }

  return (
    <nav aria-label='Footer' className='sbf-nav'>
      <div className='sbf-nav__grid'>
        {columns.map(({ key, title, links }) => (
          <div key={key} className='sbf-nav__column display-flex-column gap-1r'>
            <h2 className='sbf-heading fs-13 uppercase gBold white'>{title}</h2>
            <FooterLinkList links={links} />
          </div>
        ))}
      </div>
    </nav>
  );
}

export default FooterNav;
